import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 登入 - 重新發送 OTP 簡訊驗證碼
 */
const SendSmsOtp = [
    'POST',
    RouteUrlList.API_SendSmsOtp.path,
    {},
    200,
    {
        status: true,
        title: '發送成功',
        message: '已重新發送驗證碼至您的手機',
        errorCode: '',
        mobile: '0912***678',
        code: 0,
        letter: 'OTP 驗證碼已重新發送',
        isInWaitToSendAgain: false,
        dayLimit: 5,
        times: 2
    }
];

export default SendSmsOtp;
